module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow-first-15a258350a8ebf31abcb0534aa9a974c.png";